export function MyCoursesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M18 3h-6a4 4 0 00-4 4v10a4 4 0 004 4h6a4 4 0 004-4V7a4 4 0 00-4-4zM2 4.5a1.5 1.5 0 113 0v13.167a4 4 0 01-.8 2.4L3.5 21l-.7-.933a4 4 0 01-.8-2.4V4.5z"
        opacity="0.4"
      />
      <path fill="currentColor" d="M5 7H2V4.5a1.5 1.5 0 113 0V7z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.25 7a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zM11.25 11a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zM11.25 15a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zM22.494 16.436a.75.75 0 01.07 1.058l-2.87 3.28a1.75 1.75 0 01-2.41.214l-1.752-1.402a.75.75 0 01.936-1.172l1.753 1.403a.25.25 0 00.345-.031l2.87-3.28a.75.75 0 011.058-.07z"
        clipRule="evenodd"
      />
    </svg>
  );
}
